import { createStore } from "vuex"
import createPersistedState from "vuex-persistedstate"
import SecureLS from "secure-ls"

import auth from "./modules/auth"
import audit from "./modules/audit"
import register from "./modules/register"
import risk from "./modules/risk"
import actionsRegister from "./modules/actionsRegister"
import policyTemplate from "./modules/policyTemplate"


const ls = new SecureLS({ isCompression: false });

export default createStore({
	namespaced: true,
	modules: {
		auth,
		audit,
		register,
		risk,
		actionsRegister,
		policyTemplate,
	},
	plugins: [
		createPersistedState({
			key: "audit",
			storage: {
				getItem: (key) => ls.get(key),
				setItem: (key, value) => ls.set(key, value),
				removeItem: (key) => ls.remove(key),
			},
		}),
	],
});